export default __webpack_public_path__ + "static/winter_holiday-d2596db2610aadf9aa5d38dca464dea9.jpg";